/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_NameInputs */

const vi_packaging_material_name = /** @type {(inputs: Packaging_Material_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên vật tư`)
};

/**

* @param {Packaging_Material_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_name = /** @type {((inputs?: Packaging_Material_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_name(inputs)
});